module.exports = __webpack_public_path__ + "img/switch_model_bs.17655699.png";